import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { JssNavItem } from '@core/jss-models';
import { JssRouteBuilderService } from '@core/jss-routing';
import type { JssRouteData } from '@core/jss-utils';

@Pipe({
  name: 'navItemToJssRoute',
  standalone: true,
})
export class NavItemToJssRoutePipe implements PipeTransform {
  constructor(private readonly urlBuilder: JssRouteBuilderService) {}

  transform(navItem: JssNavItem, language?: string): JssRouteData {
    return this.urlBuilder.createRouteData(navItem, language);
  }
}
